import { render, staticRenderFns } from "./Aiuto.vue?vue&type=template&id=d02c7656&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Aiuto.vue"
export default component.exports